// extracted by mini-css-extract-plugin
module.exports = {"cat-c-list":"anchor-menu-specifications_cat-c-list___vH_X","cat-uom-container":"anchor-menu-specifications_cat-uom-container__S67jr"};